import React from 'react';
import { MapPin, Phone } from 'lucide-react';

const ContactSection = ({ settings }) => {
    if (!settings) {
        return <section id="contato" className="py-20 md:py-32"></section>;
    }

    const content = {
        schedulingLink: settings.schedulingLink || '#',
        contactTitle: settings.contactTitle || 'ENTRE EM CONTATO',
        contactSubtitle: settings.contactSubtitle || 'Sua cadeira está esperando.',
        addressText: settings.addressText || '',
        mapsLink: settings.mapsLink || '#',
        phoneText: settings.phoneText || '',
        whatsappLink: settings.whatsappLink || '#'
    };

    const formatUrl = (url) => {
        if (!url || url.trim() === '') return '#';
        if (url.startsWith('http://') || url.startsWith('https://')) {
            return url;
        }
        return `https://${url}`;
    };

    return (
        <section id="contato" className="py-20 md:py-32">
            <div className="container mx-auto px-6 text-center">
                <h2 className="text-3xl md:text-4xl font-bold mb-4 text-primary">{content.contactTitle}</h2>
                <p className="text-text/70 mb-12 max-w-xl mx-auto">{content.contactSubtitle}</p>
                
                <div className="max-w-3xl mx-auto bg-neutral-800/50 border border-primary/20 rounded-lg p-8 md:p-12">
                    <div className="grid md:grid-cols-2 gap-8 mb-12">
                        <a href={formatUrl(content.mapsLink)} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 group p-4 rounded-lg hover:bg-neutral-700/50 transition-colors">
                            <MapPin className="text-primary group-hover:scale-110 transition-transform flex-shrink-0" size={32} />
                            <div className="text-left">
                                <h3 className="font-bold text-lg">Endereço</h3>
                                <p className="text-text/80 group-hover:text-primary transition-colors">{content.addressText}</p>
                            </div>
                        </a>
                        <a href={formatUrl(content.whatsappLink)} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 group p-4 rounded-lg hover:bg-neutral-700/50 transition-colors">
                            <Phone className="text-primary group-hover:scale-110 transition-transform flex-shrink-0" size={32} />
                            <div className="text-left">
                                <h3 className="font-bold text-lg">Telefone</h3>
                                <p className="text-text/80 group-hover:text-primary transition-colors">{content.phoneText}</p>
                            </div>
                        </a>
                    </div>
                    
                    <a href={formatUrl(content.schedulingLink)} target="_blank" rel="noopener noreferrer" className="bg-button text-button-text font-bold py-4 px-10 rounded-lg text-xl hover:opacity-90 transition-opacity transform hover:scale-105 inline-block">
                        AGENDAR HORÁRIO
                    </a>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;
